import styled from 'styled-components'
import RoomChargeIcon from '../../../img/svg/roomCharge'
import { colorTheme } from '../../../style/theme/colorTheme'

export const SignaturePadWrap = styled.div`
	font-size: 1rem;
	position: relative;
	overflow: hidden;
	border: 1px solid ${colorTheme.roomCharge.signature.border};
	border-radius: 0.75em;
	background: ${colorTheme.roomCharge.signature.background};
`
SignaturePadWrap.displayName = 'SignaturePadWrap'

export const SignaturePadCanvas = styled.canvas`
	display: block;
	width: 100%;
	height: 13.12em;
	touch-action: none;
`
SignaturePadCanvas.displayName = 'SignaturePadCanvas'

export const SignaturePadPlaceholder = styled.div`
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: none;
	font-size: 1.12em;
	color: ${colorTheme.roomCharge.signature.placeholder};
`
SignaturePadPlaceholder.displayName = 'SignaturePadPlaceholder'

export const SignaturePadFooter = styled.div`
	position: absolute;
	right: 0.93em;
	bottom: 0.93em;
	left: 0.93em;
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
`
SignaturePadFooter.displayName = 'SignaturePadFooter'

export const SignaturePadCaption = styled.span`
	font-size: 0.87em;
	color: ${colorTheme.roomCharge.signature.caption};
`
SignaturePadCaption.displayName = 'SignaturePadCaption'

export const SignaturePadClearButton = styled.button`
	display: flex;
	align-items: center;
	gap: 0.37em;
	background: transparent;
	font-size: 0.87em;
	color: ${colorTheme.roomCharge.signature.clear};
`
SignaturePadClearButton.displayName = 'SignaturePadClearButton'

export const SignaturePadEraserIcon = styled(RoomChargeIcon)`
	width: 1.14em;
	height: 1.14em;
`
SignaturePadEraserIcon.displayName = 'SignaturePadEraserIcon'
